module.exports = "<ppa-loader></ppa-loader>";